import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Header from '../includes_admin/Header';
import Loading from '../Loading/Loading';
import { BannerSection } from '../includes_admin/BannerSection';

/* DATA */
import { UserContext } from "../../../context/userContext"
import { CandidateContext } from "../../../context/CandidateContext";
import { useFeature, FEATURES } from "../../../context/FeaturesContext";

import { DataPersonalApplicant } from './includes-details/DataPersonalApplicant';

/* PRE IFA */
import { DataRRSS } from './includes-details/DataRRSS';
import { DataBank } from './includes-details/DataBank';
import { DataPurchases } from './includes-details/DataPurchases';

import { TypeContract } from './includes-details/TypeContract';
import { HistoryActions } from './includes-details/HistoryActions';
import { RelatedSubUsers } from './includes-details/RelatedSubUsers';
import { ParentUserInfo } from './includes-details/ParentUserInfo';
import { TypeDocument } from './includes-details/TypeDocument';

import { ButtonsModal } from './includes-details/ButtonsModal';
import { EmploymentStatusAlert } from './includes-details/EmploymentStatusAlert';

import { API } from './../../../http-common';
import { useSnackbar } from 'react-simple-snackbar'

import { ChangeStatusContacted } from './includes-details/ChangeStatusContacted';
/* CSS */
import '../../../assets/css/new_applicant.css';
import { GROUP } from '../../../constants';
import {PROSPECT_STATUS} from "../../../constants-prod";
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../../../helpers/formatDate';
import { ROLE } from '../../../helpers/constants';

export const DetailsApplicant = () => {
    let history = useHistory();

    const optionsError = {
        position: 'bottom-right',
        style: {
            backgroundColor: 'var(--bs-red)',
            border: '0',
            color: '#fff',
            fontSize: '20px',
            textAlign: 'center',
            marginBottom: '5rem',
        },
        closeStyle: {
            color: '#fff',
            fontSize: '16px',
            marginRight: '1rem',
        },
    }

    const optionsSuccess = {
        position: 'bottom-right',
        style: {
            backgroundColor: 'var(--bs-green)',
            border: '0',
            color: '#fff',
            fontSize: '20px',
            textAlign: 'center',
            marginBottom: '5rem',
        },
        closeStyle: {
            color: '#fff',
            fontSize: '16px',
            marginRight: '1rem',
        },
    }

    const [openSnackbarSuccess] = useSnackbar(optionsSuccess)
    const [openSnackbarError] = useSnackbar(optionsError)

    const { userData } = useContext(UserContext)

    const [ checkBandkData, setCheckBandkData ] = useState( false )
    const [ checkContractData, setContractData ] = useState( false )
    const [ checkKnowingIfaData, setKnowingIfaData ] = useState( false )

    const [candidateData, setCandidateData] = useState('');
    const [loadingCandidateData, setLoadingCandidateData] = useState(true);
    const [modalsResetTick, setModalsResetTick] = useState(0);
    const [subDocsRefreshTick, setSubDocsRefreshTick] = useState(0);

    /* Todo lo de subusuarios depende de este flag: con la feature apagada se trata a todos como usuarios principales */
    const subProspectsEnabled = useFeature(FEATURES.SUBPROSPECTS)
    const isSubUser = subProspectsEnabled && Boolean(candidateData?.parent_prospect_id)

    const ProviderCandidateData = useMemo(() => ({
    candidateData,
    setCandidateData,
    isSubUser,
    knowingIfaValid: checkKnowingIfaData,
    setKnowingIfaValid: setKnowingIfaData
    }), [candidateData, setCandidateData, isSubUser, checkKnowingIfaData]);


    const [asesor, setAsesor] = useState("")

    const [loadingBtn, setLoadingBtn] = useState(false);
    
    const candidato_id = history.location.state.candidato_id;

    const STATUS_SHOW_BTN_CONTACTADO = [PROSPECT_STATUS.PRE_CANDIDATO, PROSPECT_STATUS.CONTACTADO];

    useEffect(() => {
        if( candidato_id ) {
            getProspectById( candidato_id )
        }
    }, [candidato_id])

    /* APROBAR AL CANDIDATO PARA UN NUEVO CODIGO DE ESTATUS */
    const setAprove = async ( candidato_id, status,source ) => {
        setLoadingBtn(status === 102 && !loadingBtn)

        /* ROL QUE APRUEBA */
        console.log(`setAprove candidato => `, candidato_id)
        await API.post(`/prospects/status/${candidato_id}/${status}`,{sc_avanza:source})
        .then(function (response) {
            console.log(`setAprove response => `, response)
            openSnackbarSuccess(`Se ha actualizado el estado`)
            setLoadingBtn(false)
            if (isSubUser) {
                getProspectById(candidato_id)
                setModalsResetTick(tick => tick + 1)
            } else {
                window.history.back();
            }

        })
        .catch(function (error) {
            setLoadingBtn(false)
            if(error.response){
                openSnackbarError(`No se pudo aprobar al postulante` )
            }
        });
    }
    async function resendMailProspect (candidato_id, setGenerateContractOpen) {
        setLoadingBtn(true)
        console.log(`resendMailProspect candidato => `, candidato_id)
        
        await API.post(`/prospects/send-mail/${candidato_id}`)
        .then(function (response) {
            console.log(`resendMailProspect response => `, response)
            openSnackbarSuccess(`Se ha reenviado el correo`);
            setLoadingBtn(false)
            setGenerateContractOpen(false)
        })
        .catch(function (error) {
            if(error.response){
                setLoadingBtn(false)
                setGenerateContractOpen(false)
                openSnackbarError(`No se pudo reenviar el correo` )
            }
        });
    }

    async function retryCreateProvider (candidato_id) {
        setLoadingBtn(true)
        console.log(`retryCreateProvider candidato => `, candidato_id)
        
        await API.post(`/prospects/reattempt-provider/${candidato_id}`)
        .then(function (response) {
            console.log(`retryCreateProvider response => `, response)
            openSnackbarSuccess(`Se ha reintentado crear el candidato como proveedor`);
            setLoadingBtn(false)
        })
        .catch(function (error) {
            console.log("error", error)
                setLoadingBtn(false)
                openSnackbarError(error?.response?.data?.msg || error?.msg || `No se pudo reintentar` )
        });
    }

    const setReject = async ( candidato_id, msg, code_id ) => {
        /* ROL QUE APRUEBA */
        console.log(`Reject candidato => `, candidato_id, msg)
        await API.post(`/prospects/status/${candidato_id}/${code_id}`, {message: msg})
        .then(function (response) {
            console.log(`Reject response => `, response)
            openSnackbarSuccess(`Se ha actualizado el estado`);
            if (isSubUser) {
                getProspectById(candidato_id)
                setModalsResetTick(tick => tick + 1)
            } else {
                window.history.back();
            }
        })
        .catch(function (error) {
            if(error.response){
                openSnackbarError(`No se pudo rechazar al postulante` )
            }
        });
    }
    const setChangeStatusContacted = async (candidato_id, prospect_status, status,isChecked) =>{
        setLoadingBtn(true)
        console.log(`Change Status Contacted => `, candidato_id, status)
        await API.post(`/prospects/status/${candidato_id}/${status}/${prospect_status}`,{isChecked})
        .then(function (response) {
            console.log(`Change Status Contacted response => `, response)
            openSnackbarSuccess(`Se ha actualizado el estado`);
            window.location.reload();
        })
        .catch(function (error) {
            setLoadingBtn(false)
            if(error.response){
                openSnackbarError(`No se pudo actualizar el estado` )
            }
        })
    }
    /* SET PENDIENTE AL CANDIDATO */
    const setPendingProspect = async ( candidato_id ) => {
        window.history.back();
        // await API.post(`/prospects/set_pending/${candidato_id}`)
        //     .then(function (response) {
        //         console.log(`setPendingProspect data =>`, response)
        //         openSnackbarSuccess("Se ha actualizado el estatus a [PENDIENTE] ");
        //     })
        //     .catch( function(error) {
        //         console.log(`setPendingProspect error =>`, error.response)
        //         const msg = error.response.data.errors[0].msg ? error.response.data.errors[0].msg : "Error: no se pudo llevar a cabo la acción";
        //         openSnackbarError(msg);
        //     })
    }

    const sendOtherArea = async (candidato_id, msg, code_id, source, manual_contract_status = '') => {
        console.log(`change area=> `, candidato_id, msg, code_id, manual_contract_status);
        await API.post(`/prospects/status/${candidato_id}/${code_id}`, { message: msg, sc_retrocede: source, manual_contract_status })
            .then(function (response) {
                console.log(`change area response => `, response);
                openSnackbarSuccess(`Se ha enviado al prospecto a ${(GROUP.EQ_SOPORTE.includes(userData.role_id) && candidateData.prospect_status !== PROSPECT_STATUS.SC_APROBADO_COMPLIANCE) ? "Equipo Comercial" : "Soporte Comercial"}`);
                if (isSubUser) {
                    getProspectById(candidato_id)
                    setModalsResetTick(tick => tick + 1)
                } else {
                    window.history.back();
                }
            })
            .catch(function (error) {
                if (error.response) {
                    openSnackbarError(`No se pudo actualizar al postulante`);
                }
            });
    }

    const voidDocuSignContract = async (candidato_id, reason) => {
        console.log(`Anulando contrato para candidato => `, candidato_id, ` con razón: ${reason}`);
        try {
            const response = await API.post(`/prospects/contracts/${candidato_id}/void`, { reason });
            console.log(`voidDocuSignContract response => `, response);
            openSnackbarSuccess("Se ha anulado el contrato correctamente");
            getProspectById(candidato_id);
            return true;
        } catch (error) {
            console.error("Error al anular contrato:", error);
            const errorMessage = error.response?.data?.message || "No se pudo anular el contrato";
            openSnackbarError(errorMessage);
            return false;
        }
    }

    const updateDocuSignStatus = async (candidato_id) => {
        console.log(`Actualizando estado del contrato para candidato => `, candidato_id);
        try {
            const response = await API.post(`/prospects/contracts/${candidato_id}/update-status`);
            console.log(`updateDocuSignStatus response => `, response);
            openSnackbarSuccess("Se ha actualizado el estado del contrato correctamente");
            getProspectById(candidato_id);
            return true;
        } catch (error) {
            console.error("Error al actualizar estado del contrato:", error);
            openSnackbarError("No se pudo actualizar el estado del contrato");
            return false;
        }
    }

    async function getProspectById(candidato_id) {
        setLoadingCandidateData(true);
        await API.get(`/prospects/${candidato_id}`)
        .then(function (response) {
            let data = response.data.data;
            setCandidateData( data )
        })
        .catch( function(error) {
            //console.log(`getProspectById => error`, error.response)
            openSnackbarError('Error al obtener los datos')
        })
        .finally(() => {
            setLoadingCandidateData(false);
        })
    }

    /* Al cambiar los usuarios principales cambian los documentos y, si cambió el principal, el director/asesor heredado */
    const handleParentsChange = () => {
        getProspectById(candidato_id)
        setSubDocsRefreshTick(tick => tick + 1)
    }

    const isPendingPsychoTech = Number(userData?.role_id) === ROLE.RRHH

    /* Solo en la carga inicial: los refrescos in-place (subusuarios) no deben desmontar la página */
    if (loadingCandidateData && !candidateData) {
        return <Loading />
    }

    return (

        <CandidateContext.Provider value={ ProviderCandidateData } >
            <div className="container-fluid" id="applicant_container_fluid">
                <div className="row mb-4">
                    <Header />
                </div>

                <BannerSection user_role={userData.role_id} prospect_status={ candidateData.prospect_status }/>

                {subProspectsEnabled && (
                    <>
                        <ParentUserInfo onParentsChange={handleParentsChange} />
                        <RelatedSubUsers />
                    </>
                )}
                <div className="applicant_content_width">
                {candidateData?.hasRescindedContract && (
                    <Alert variant="danger" className="rescinded-contract-alert">
                        <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 22, color: '#fff' }} className="me-3" />
                        ESTE CANDIDATO{" "}
                        <strong>{candidateData?.complete_name}</strong>{" "}
                        con CUIT{" "}
                        <strong>{candidateData?.cuit}</strong>{" "}
                        TUVO UN CONTRATO RESCINDIDO{" "}
                        {candidateData?.rescindedContract?.rescissionDate && (
                            <>
                                EL{" "}
                                <strong>
                                    {formatDate(candidateData.rescindedContract.rescissionDate)}
                                </strong>
                            </>
                        )}
                        {candidateData?.rescindedContract?.unidad && (
                            <>
                            {" "}Y PERTENECÍA A LA UNIDAD{" "}
                            <strong>{candidateData.rescindedContract.unidad}</strong>
                            </>
                        )}
                        .
                    </Alert>
                )}
                </div>
                <EmploymentStatusAlert employmentStatus={candidateData?.employment_status} tipoAsesor={candidateData?.tipo_asesor} />
                <br/>

                <DataPersonalApplicant setAdviser={setAsesor} />
                <br/>
                <DataPurchases user_role={userData.role_id} />
                {candidateData.prospect_status < 30 &&
                    <>
                        <DataRRSS />
                        <br/>

                        <DataBank
                            user_role={ userData.role_id }
                            setCheckBandkData={ setCheckBandkData }
                         />
                        <br/>
                        <br/>
                    </>
                }

                {!isPendingPsychoTech && candidateData.prospect_status >= 30 && (
                    isSubUser ? (
                        <>
                            <TypeDocument check_data={setContractData} refreshKey={subDocsRefreshTick} />
                            <br/>
                        </>
                    ) : (
                        <>
                            <TypeContract user_role={ userData.role_id } check_data={setContractData} />
                            <br/>
                        </>
                    )
                )}

                <br/>
                <br/>

                {GROUP.EQ_DIRECTORES.includes(userData.role_id) && STATUS_SHOW_BTN_CONTACTADO.includes(candidateData.prospect_status) && (
                    <ChangeStatusContacted
                        candidateData={candidateData}
                        setChangeStatusContacted={setChangeStatusContacted}
                        loading_btn={loadingBtn}
                    />
                )}

                <br/>
                <ButtonsModal
                    user_role={ userData.role_id }
                    is_balanz={ candidateData.is_balanz }
                    set_approve={ setAprove }
                    set_pending={ setPendingProspect }
                    set_reject={ setReject }
                    set_other_area={ sendOtherArea }
                    checkBandkData={ checkBandkData }
                    check_contract_data={ checkContractData}
                    loading_btn={loadingBtn}
                    resendMailProspect={resendMailProspect}
                    retryCreateProvider={retryCreateProvider}
                    voidDocuSignContract={voidDocuSignContract}
                    updateDocuSignStatus={updateDocuSignStatus}
                    closeModalsSignal={modalsResetTick}
                />

                <HistoryActions prospectsId={candidato_id} />
                <br/>
                <br/>

            </div>
        </CandidateContext.Provider>
    )
}

